import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2vp3ue16: FaireBrandEntity = {
  token: "b_2vp3ue16",
  type: "brand",
  name: "Nikki Smith Designs",
  avatarUrl:
    "https://cdn.faire.com/fastly/bbb89d47b221743d044ddf3cc75dbeb255c6bd365d1d5ed2d858517e4b533c84.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/2825bcfd187a7f1ea9bdbb3a453012694abf9b3a26fb5a9a8ef12bc1d5b71c64.png",
  logoUrl:
    "https://cdn.faire.com/fastly/bbb89d47b221743d044ddf3cc75dbeb255c6bd365d1d5ed2d858517e4b533c84.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2825bcfd187a7f1ea9bdbb3a453012694abf9b3a26fb5a9a8ef12bc1d5b71c64.png",
  location: "Dallas, TX, USA",
  minimumOrderDollars: 250,
  rating: 5,
  reviewCount: 186,
  isTopShop: true,
  isInsider: true,
  description:
    "Hi! My name is Nikki, and my team and I create modern, high-quality jewelry that’s fun to layer and stack at an affordable price point. Every piece in our collection is retails under  $50 (with a 60% IMU) and is designed for everyday wear. We love partnering with retailers and supporting your store environment by offering stylish, on-trend jewelry—along with curated displays to help showcase the collection if needed. All items come tagged, earrings come on our branded cards. We are based in Dallas, TX.\n\nI fell in love with designing and hand-making jewelry in 2016, creating pieces I could easily layer and wear to my corporate buying job. When women began asking where my jewelry was from, it inspired me to turn that passion into a brand. Each piece is thoughtfully designed using quality materials and intentionally crafted to look beautiful worn alone or layered.\n\nMaterials Used: Our jewelry is waterproof, made with gold/silver plating  and stainless-steel materials featuring PVD plating to give it a water resisant coat. \n\nPlease don’t hesitate to reach out with any questions—we’ll respond as quickly as possible. Thank you so much for the opportunity to work together! ",
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:38:31.001Z",
    importedBy: "entity-db-cli",
  },
};
